import React, { useState, useEffect, useRef } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import firebaseApp from "../../firebase/credenciales";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  ProgressBar,
  Row,
  Col,
  Badge,
  Alert,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  FaCopy,
  FaFilePdf,
  FaDownload,
  FaUsers,
  FaSearch,
  FaExclamationTriangle,
  FaFileAlt,
  FaSync,
  FaCog,
  FaShieldAlt,
  FaInfo,
} from "react-icons/fa";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

const db = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp);

const meses = [
  { nombre: "Enero", valor: "01" },
  { nombre: "Febrero", valor: "02" },
  { nombre: "Marzo", valor: "03" },
  { nombre: "Abril", valor: "04" },
  { nombre: "Mayo", valor: "05" },
  { nombre: "Junio", valor: "06" },
  { nombre: "Julio", valor: "07" },
  { nombre: "Agosto", valor: "08" },
  { nombre: "Septiembre", valor: "09" },
  { nombre: "Octubre", valor: "10" },
  { nombre: "Noviembre", valor: "11" },
  { nombre: "Diciembre", valor: "12" },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 7 }, (_, i) => (currentYear + 1 - i).toString());

const tiposDocumento = [
  { id: "PoliticasLaborales", label: "POLITICA SALARIAL / LABORAL" },
  { id: "Reglamentos", label: "REGLAMENTO INTERNO" },
  { id: "Memorandums", label: "MEMORANDUM" },
  { id: "Contratos", label: "CONTRATOS" },
  { id: "Boletas de pago", label: "BOLETAS DE PAGO" },
  { id: "Otros", label: "OTROS DOCUMENTOS" },
];

const DuplicarDocumentoMasivo = ({ usuario, ruc: rucProp }) => {
  const [empresaRuc, setEmpresaRuc] = useState(usuario?.ruc || rucProp || "");
  const [empresaNombre, setEmpresaNombre] = useState(usuario?.name || "");
  const [empresasLista, setEmpresasLista] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);

  // Formulario Documento
  const [archivoBase, setArchivoBase] = useState(null);
  const [tituloDoc, setTituloDoc] = useState("");
  const [tipoDoc, setTipoDoc] = useState("PoliticasLaborales");
  const [mes, setMes] = useState(
    (new Date().getMonth() + 1).toString().padStart(2, "0")
  );
  const [ano, setAno] = useState(currentYear.toString());

  // Estados de proceso
  const [procesandoZip, setProcesandoZip] = useState(false);
  const [progreso, setProgreso] = useState(0);
  const [mensajeEstado, setMensajeEstado] = useState("");
  const [filtroTabla, setFiltroTabla] = useState("");

  const fileInputRef = useRef(null);

  // Cargar RUCs de empresas si existe lista en Firestore
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const snap = await getDocs(collection(db, "company"));
        const lista = [];
        snap.forEach((d) => {
          const data = d.data();
          if (data.ruc) {
            lista.push({ ruc: data.ruc, name: data.name || data.ruc });
          }
        });
        setEmpresasLista(lista);
      } catch (err) {
        console.error("Error al cargar empresas:", err);
      }
    };
    fetchEmpresas();
  }, []);

  // Cargar datos de la empresa actual
  useEffect(() => {
    if (!empresaRuc) return;
    const fetchInfoEmpresa = async () => {
      try {
        const docSnap = await getDoc(doc(db, "company", empresaRuc));
        if (docSnap.exists()) {
          setEmpresaNombre(docSnap.data().name || empresaRuc);
        }
      } catch (e) {
        console.error("Error consultando empresa:", e);
      }
    };
    fetchInfoEmpresa();
  }, [empresaRuc]);

  // Cargar colaboradores filtrados por RUC desde la colección 'users'
  const cargarColaboradores = async () => {
    if (!empresaRuc) {
      Swal.fire("Atención", "Por favor ingresa o selecciona un RUC de empresa.", "warning");
      return;
    }
    setCargandoUsuarios(true);
    try {
      const rucLimpio = String(empresaRuc).trim();
      const rucNum = Number(rucLimpio);
      const isNum = !isNaN(rucNum) && rucLimpio !== "";

      const usersRef = collection(db, "users");
      const promesas = [
        getDocs(query(usersRef, where("ruc", "==", rucLimpio))),
        getDocs(query(usersRef, where("rucEmpresa", "==", rucLimpio))),
      ];

      if (isNum) {
        promesas.push(getDocs(query(usersRef, where("ruc", "==", rucNum))));
        promesas.push(getDocs(query(usersRef, where("rucEmpresa", "==", rucNum))));
      }

      const snapshots = await Promise.all(promesas);
      const mapUsuarios = new Map();

      snapshots.forEach((snap) => {
        snap.forEach((d) => {
          const data = d.data();
          const dniClean = data.dni ? String(data.dni).trim() : d.id.trim();
          if (dniClean && dniClean.length >= 7) {
            mapUsuarios.set(dniClean, {
              id: d.id,
              dni: dniClean,
              nombre: `${data.name || data.nombre || data.nombres || ""} ${data.apellidos || data.apellido || ""}`.trim() || "Sin Nombre",
              email: data.email || "",
              area: data.area || data.departamento || "N/A",
              cargo: data.cargo || "N/A",
            });
          }
        });
      });

      // Si no devolvió por queries, fallback
      if (mapUsuarios.size === 0) {
        const fullSnap = await getDocs(usersRef);
        fullSnap.forEach((d) => {
          const data = d.data();
          const userRuc = String(data.ruc || data.rucEmpresa || data.empresaRuc || "").trim();
          if (userRuc === rucLimpio) {
            const dniClean = data.dni ? String(data.dni).trim() : d.id.trim();
            if (dniClean && dniClean.length >= 7) {
              mapUsuarios.set(dniClean, {
                id: d.id,
                dni: dniClean,
                nombre: `${data.name || data.nombre || data.nombres || ""} ${data.apellidos || data.apellido || ""}`.trim() || "Sin Nombre",
                email: data.email || "",
                area: data.area || data.departamento || "N/A",
                cargo: data.cargo || "N/A",
              });
            }
          }
        });
      }

      const lista = Array.from(mapUsuarios.values()).sort((a, b) =>
        a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" })
      );
      setColaboradores(lista);

      if (lista.length === 0) {
        Swal.fire(
          "Sin colaboradores",
          `No se encontraron usuarios en la colección 'users' para el RUC: ${empresaRuc}`,
          "info"
        );
      }
    } catch (err) {
      console.error("Error al obtener colaboradores por RUC:", err);
      Swal.fire("Error", "No se pudieron obtener los colaboradores de la empresa.", "error");
    } finally {
      setCargandoUsuarios(false);
    }
  };

  useEffect(() => {
    if (empresaRuc) {
      cargarColaboradores();
    }
  }, [empresaRuc]);

  // Reset del formulario
  const handleReset = () => {
    setArchivoBase(null);
    setTituloDoc("");
    setProgreso(0);
    setMensajeEstado("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Función para obtener ArrayBuffer del archivo (con conversión Word -> PDF si aplica)
  const getArrayBufferFromFile = async (file) => {
    if (
      file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      file.type === "application/msword" ||
      file.name.toLowerCase().endsWith(".docx") ||
      file.name.toLowerCase().endsWith(".doc")
    ) {
      setMensajeEstado(`Convirtiendo Word (${file.name}) a PDF...`);
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });

      const convertWordToPdf = httpsCallable(functions, "convertWordToPdf");
      const result = await convertWordToPdf({ base64, fileName: file.name });
      const pdfBase64 = result.data.pdfBase64;

      const binaryString = window.atob(pdfBase64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }
    return await file.arrayBuffer();
  };

  // Sanitizar título para nombres de archivos
  const sanitizarNombre = (str) => {
    return str
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9\s\-_]/g, "")
      .replace(/\s+/g, " ");
  };

  // ACCIÓN: Generar y descargar ZIP con las copias renombradas (DNI-TITULO)
  const handleDescargarZIP = async () => {
    if (!archivoBase) {
      Swal.fire("Atención", "Por favor selecciona un archivo (PDF o Word).", "warning");
      return;
    }
    if (!tituloDoc.trim()) {
      Swal.fire("Atención", "Por favor ingresa el título del documento (ej: POLITICA SALARIAL).", "warning");
      return;
    }
    if (colaboradores.length === 0) {
      Swal.fire("Atención", "No hay colaboradores para este RUC.", "warning");
      return;
    }

    setProcesandoZip(true);
    setProgreso(0);
    setMensajeEstado("Preparando archivo base...");

    try {
      const buffer = await getArrayBufferFromFile(archivoBase);
      const zip = new JSZip();
      const tituloClean = sanitizarNombre(tituloDoc);
      const total = colaboradores.length;

      for (let i = 0; i < total; i++) {
        const c = colaboradores[i];
        const fileName = `${c.dni}-${tituloClean}.pdf`;
        zip.file(fileName, buffer);

        const prog = Math.round(((i + 1) / total) * 100);
        setProgreso(prog);
        setMensajeEstado(`Generando copia ${i + 1} de ${total}: ${fileName}`);
      }

      setMensajeEstado("Comprimiendo archivo ZIP...");
      const content = await zip.generateAsync({ type: "blob" });
      const nombreZip = `Duplicados_${tituloClean}_RUC_${empresaRuc}.zip`;
      saveAs(content, nombreZip);

      Swal.fire({
        icon: "success",
        title: "¡ZIP Generado con Éxito!",
        text: `Se descargaron ${total} copias renombradas en ${nombreZip}`,
      });
    } catch (err) {
      console.error("Error al generar ZIP:", err);
      Swal.fire("Error", "Ocurrió un error al empaquetar los archivos ZIP.", "error");
    } finally {
      setProcesandoZip(false);
      setProgreso(0);
      setMensajeEstado("");
    }
  };

  const colaboradoresFiltrados = colaboradores.filter(
    (c) =>
      c.dni.includes(filtroTabla) ||
      c.nombre.toLowerCase().includes(filtroTabla.toLowerCase())
  );

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado verde oscuro */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div
              className="position-absolute end-0 top-50 translate-middle-y me-4"
              style={{ zIndex: 10 }}
            >
              <BotonManualHeader manualKey="DUPLICAR_DOCUMENTO_MASIVO" />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaCopy className="me-3" />
                Duplicar y Renombrar Documentos por RUC
              </h2>
              <p className="mb-0 opacity-75">
                Genera copias automáticas etiquetadas con el DNI del trabajador y el título del documento (DNI-Título)
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Indicador de RUC activo */}
            {empresaRuc && (
              <Alert
                variant="info"
                className="mb-4"
                style={{ borderRadius: "15px" }}
              >
                <div className="d-flex align-items-center">
                  <FaShieldAlt
                    size={24}
                    className="me-3"
                    style={{ color: "#0dcaf0" }}
                  />
                  <div>
                    <strong>Empresa Seleccionada:</strong> {empresaNombre || empresaRuc} (RUC: {empresaRuc}) —{" "}
                    <strong>{colaboradores.length} colaboradores detectados</strong>.
                  </div>
                </div>
              </Alert>
            )}

            {/* Barra superior con controles */}
            <Card
              className="shadow-sm border-0 mb-4"
              style={{ borderRadius: "15px" }}
            >
              <Card.Body className="p-4">
                <Row className="align-items-center">
                  <Col md={1}>
                    <div
                      className="rounded-3 p-3 text-center"
                      style={{
                        background:
                          "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        color: "white",
                      }}
                    >
                      <FaCog size={24} />
                    </div>
                  </Col>
                  <Col md={9}>
                    <h5 className="mb-1 fw-semibold">
                      Configuración de Procesamiento por RUC
                    </h5>
                    <p className="text-muted mb-0 small">
                      Establece el título, período y archivo máster para generar la descarga comprimida
                    </p>
                  </Col>
                  <Col md={2} className="text-end">
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Reiniciar configuración</Tooltip>}
                    >
                      <Button
                        variant="outline-secondary"
                        onClick={handleReset}
                        disabled={procesandoZip}
                        className="d-flex align-items-center gap-2"
                        style={{ borderRadius: "10px" }}
                      >
                        <FaSync size="16px" />
                        Reiniciar
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Formulario de configuración */}
            <Card
              className="shadow-sm border-0 mb-4"
              style={{ borderRadius: "15px" }}
            >
              <Card.Header
                className="text-white py-3"
                style={{
                  background:
                    "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0",
                }}
              >
                <div className="d-flex align-items-center">
                  <FaFileAlt className="me-2" />
                  <div>
                    <h5 className="mb-0 fw-semibold">
                      Parámetros del Documento Máster
                    </h5>
                    <small className="opacity-75">
                      Ingresa el título y carga el archivo PDF o Word a duplicar
                    </small>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="p-4">
                <Form>
                  <Row className="g-3 mb-4">
                    {/* Selección de Empresa / RUC */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          Empresa (RUC)
                        </Form.Label>
                        {empresasLista.length > 1 ? (
                          <Form.Select
                            value={empresaRuc}
                            onChange={(e) => setEmpresaRuc(e.target.value)}
                            className="form-control-lg"
                            style={{ borderRadius: "10px" }}
                          >
                            <option value="">Selecciona Empresa...</option>
                            {empresasLista.map((emp) => (
                              <option key={emp.ruc} value={emp.ruc}>
                                {emp.name} ({emp.ruc})
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Control
                            type="text"
                            value={empresaRuc ? `${empresaNombre} (${empresaRuc})` : ""}
                            onChange={(e) => setEmpresaRuc(e.target.value)}
                            placeholder="Ingrese RUC de la Empresa"
                            className="form-control-lg"
                            style={{ borderRadius: "10px" }}
                          />
                        )}
                        <small className="text-muted">
                          RUC emisor para filtrar colaboradores
                        </small>
                      </Form.Group>
                    </Col>

                    {/* Título del Documento */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          Título del Documento <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Ej. POLITICA SALARIAL, REGLAMENTO INTERNO"
                          value={tituloDoc}
                          onChange={(e) => setTituloDoc(e.target.value)}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        />
                        <small className="text-muted">
                          Nombre final: <code>DNI-{sanitizarNombre(tituloDoc || "TITULO")}.pdf</code>
                        </small>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 mb-4">
                    {/* Categoría / Tipo de Documento */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          Tipo de Documento
                        </Form.Label>
                        <Form.Select
                          value={tipoDoc}
                          onChange={(e) => setTipoDoc(e.target.value)}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        >
                          {tiposDocumento.map((td) => (
                            <option key={td.id} value={td.id}>
                              {td.label}
                            </option>
                          ))}
                        </Form.Select>
                        <small className="text-muted">
                          Categoría organizativa del documento
                        </small>
                      </Form.Group>
                    </Col>

                    {/* Mes */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="fw-bold">Mes</Form.Label>
                        <Form.Select
                          value={mes}
                          onChange={(e) => setMes(e.target.value)}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        >
                          {meses.map((m) => (
                            <option key={m.valor} value={m.valor}>
                              {m.nombre}
                            </option>
                          ))}
                        </Form.Select>
                        <small className="text-muted">Mes de emisión</small>
                      </Form.Group>
                    </Col>

                    {/* Año */}
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="fw-bold">Año</Form.Label>
                        <Form.Select
                          value={ano}
                          onChange={(e) => setAno(e.target.value)}
                          className="form-control-lg"
                          style={{ borderRadius: "10px" }}
                        >
                          {years.map((y) => (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          ))}
                        </Form.Select>
                        <small className="text-muted">Año del período</small>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Archivo Base (PDF o Word) */}
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-bold">
                      Documento Máster (PDF o Word) <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      ref={fileInputRef}
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setArchivoBase(e.target.files[0] || null)}
                      className="form-control-lg"
                      style={{ borderRadius: "10px" }}
                    />
                    {archivoBase && (
                      <div className="mt-2 p-3 bg-light rounded-3 d-flex align-items-center gap-2 border">
                        <FaFilePdf className="text-danger" size={20} />
                        <span className="fw-semibold text-truncate me-auto">{archivoBase.name}</span>
                        <Badge bg="secondary" className="px-2 py-1">
                          {(archivoBase.size / 1024 / 1024).toFixed(2)} MB
                        </Badge>
                      </div>
                    )}
                  </Form.Group>

                  {/* Barra de progreso */}
                  {procesandoZip && (
                    <div className="mb-4">
                      <div className="d-flex justify-content-between small text-muted mb-1">
                        <span>{mensajeEstado}</span>
                        <span>{progreso}%</span>
                      </div>
                      <ProgressBar animated now={progreso} variant="success" style={{ height: "10px", borderRadius: "5px" }} />
                    </div>
                  )}

                  {/* Botón de Acción Principal */}
                  <div className="text-end">
                    <Button
                      variant="success"
                      size="lg"
                      onClick={handleDescargarZIP}
                      disabled={procesandoZip || !archivoBase || !tituloDoc.trim() || colaboradores.length === 0}
                      className="px-4 py-3 fw-bold d-inline-flex align-items-center gap-2"
                      style={{
                        background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                        border: "none",
                        borderRadius: "10px",
                        boxShadow: "0 4px 15px rgba(13, 79, 60, 0.3)",
                      }}
                    >
                      {procesandoZip ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <FaDownload size={18} />
                      )}
                      Generar y Descargar Paquete ZIP
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>

            {/* Lista de Colaboradores */}
            <Card
              className="shadow-sm border-0"
              style={{ borderRadius: "15px" }}
            >
              <Card.Header
                className="text-white py-3 d-flex align-items-center justify-content-between"
                style={{
                  background:
                    "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                  borderRadius: "15px 15px 0 0",
                }}
              >
                <div className="d-flex align-items-center">
                  <FaUsers className="me-2" />
                  <div>
                    <h5 className="mb-0 fw-semibold">
                      Colaboradores Filtrados en Colección Users
                    </h5>
                    <small className="opacity-75">
                      Vista previa de los archivos que serán generados en el archivo comprimido
                    </small>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Badge bg="light" text="dark" className="fs-6 px-3 py-2 rounded-pill">
                    {colaboradores.length} Trabajadores
                  </Badge>
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={cargarColaboradores}
                    title="Recargar colaboradores"
                    className="rounded-circle p-2 d-flex align-items-center justify-content-center"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <FaSync className={cargandoUsuarios ? "spin" : ""} />
                  </Button>
                </div>
              </Card.Header>

              <Card.Body className="p-4">
                {/* Buscador interno */}
                <Row className="mb-3">
                  <Col md={6}>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        placeholder="Buscar por DNI o Nombre..."
                        value={filtroTabla}
                        onChange={(e) => setFiltroTabla(e.target.value)}
                        className="form-control-lg ps-5"
                        style={{ borderRadius: "10px" }}
                      />
                      <FaSearch
                        className="position-absolute text-muted"
                        style={{ left: "15px", top: "50%", transform: "translateY(-50%)" }}
                      />
                    </div>
                  </Col>
                </Row>

                {cargandoUsuarios ? (
                  <div className="text-center py-5">
                    <Spinner animation="border" style={{ color: "#0d4f3c" }} />
                    <p className="text-muted mt-2">Cargando colaboradores desde la colección <code>users</code>...</p>
                  </div>
                ) : colaboradores.length === 0 ? (
                  <Alert variant="warning" className="border-0" style={{ borderRadius: "15px" }}>
                    <FaExclamationTriangle className="me-2" />
                    No se encontraron usuarios en la colección <code>users</code> para el RUC <strong>{empresaRuc}</strong>.
                  </Alert>
                ) : (
                  <div className="table-responsive" style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <Table hover align="middle" className="mb-0">
                      <thead
                        style={{
                          background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                          color: "white",
                        }}
                      >
                        <tr>
                          <th className="py-3 px-3">#</th>
                          <th className="py-3 px-3">DNI</th>
                          <th className="py-3 px-3">Colaborador</th>
                          <th className="py-3 px-3">Nombre de Archivo Final (DNI-Título)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {colaboradoresFiltrados.map((c, idx) => {
                          const tituloClean = sanitizarNombre(tituloDoc || "TITULO");
                          const nombreArchivoGenerado = `${c.dni}-${tituloClean}.pdf`;
                          return (
                            <tr key={c.id || idx}>
                              <td className="py-3 px-3">
                                <Badge bg="dark" className="px-2 py-1">
                                  {idx + 1}
                                </Badge>
                              </td>
                              <td className="py-3 px-3 fw-bold text-dark">{c.dni}</td>
                              <td className="py-3 px-3">
                                <div className="fw-semibold text-dark">{c.nombre}</div>
                                <small className="text-muted">{c.email || c.area}</small>
                              </td>
                              <td className="py-3 px-3">
                                <div className="d-flex align-items-center gap-2">
                                  <div
                                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      background:
                                        "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
                                      color: "white",
                                    }}
                                  >
                                    <FaFilePdf size="12px" />
                                  </div>
                                  <Badge bg="light" text="dark" className="border px-2 py-2 font-monospace fs-6">
                                    {nombreArchivoGenerado}
                                  </Badge>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default DuplicarDocumentoMasivo;
